import React from 'react';
import styled from 'styled-components';

import Actions from './Actions';
import DesktopMenu from './DesktopMenu';
import Logo from './Logo';

const Header = (props) => {
  const { mode } = props;

  return (
    <>
      <Wrapper mode={mode}>
        <Container>
          <Logo mode={mode} />
          <DesktopMenu mode={mode} />
          <Actions mode={mode} />
        </Container>
      </Wrapper>
    </>
  );
};

const Wrapper = styled.header`
  height: 116px;
  display: flex;
  align-items: center;
  z-index: 100;
  padding: 0 20px;
  background-color: ${({ mode }) =>
    mode === 'dark' ? 'rgb(10,17,44)' : 'white'};
  ${({ theme }) => `
    @media ${theme.mediumUp} {
      padding: 0 50px;
    }
  `}
`;

const Container = styled.div`
  max-width: 1700px;
  margin: auto;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default Header;
